import React from 'react';
import { Box, Divider, Skeleton, Stack } from '@mui/material';

// Skeleton mirrors the compact customer profile layout shown after lookup
export const CustomerProfileSkeleton: React.FC = () => {
  return (
    <Stack spacing={1.5} sx={{ mt: 2 }} aria-label="Loading customer profile" role="status">
      {/* Name */}
      <Skeleton variant="text" width="65%" height={28} />

      {/* Action buttons */}
      <Skeleton variant="rectangular" width="100%" height={34} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width="100%" height={34} sx={{ borderRadius: 1 }} />

      <Divider />

      {/* Labeled fields: SECTION, MOS, WORKFORCE CATEGORY, POSITION */}
      {['SECTION', 'MOS', 'WORKFORCE CATEGORY', 'POSITION'].map((_, index) => (
        <Box key={index}>
          <Skeleton variant="text" width={90 + index * 20} height={14} />
          <Skeleton variant="text" width="70%" height={20} />
        </Box>
      ))}
    </Stack>
  );
};
